import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { CampaignPostDetailsModal } from '@anytag/shared-molecules';
import { InfluencerSponsoredPost, SocialAccountStatus } from '@anytag/graphql';
import { useInfluencerSponsoredPostsListTable } from './hooks';

export interface InfluencerSponsoredPostsListProps extends TableData<InfluencerSponsoredPost> {
  influencerId?: number;
  status?: SocialAccountStatus;
}

export const InfluencerSponsoredPostsList = ({
  status,
  loading,
  data = [],
  influencerId
}: InfluencerSponsoredPostsListProps) => {
  const { columns } = useInfluencerSponsoredPostsListTable({ status });

  return (
    <>
      <TableV2 loading={loading} rowHeight="62px" columns={columns} data={data} noTopBorderRadius hasBorder />

      <CampaignPostDetailsModal
        posts={data.map(({ id, campaignType }) => ({ id: String(id), influencerId, campaignType }))}
      />
    </>
  );
};
